import Row from 'components/Row';
import React, { useState } from 'react';
import styled from 'styled-components';
import { TYPE } from 'theme';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { GradientShadowBox } from 'components/styled/Box';
import { CardStyles } from 'theme/commonStyles';
import { isMobile } from 'react-device-detect';

const FAQWrapper = styled(GradientShadowBox).attrs((props) => ({
    top: -200,
    left: isMobile ? 0 : 150,
    right: isMobile ? 0 : 150,
    height: 300,
    background: props.theme.c.radialGradientBg,
    blur: 100,
}))`
    ${CardStyles}
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: 5%;
    width: 100%;
    border-radius: 24px;
    margin-top: 150px;
    flex-direction: column;

    ${({ theme }) => theme.mediaWidth.upToSmall`
        margin: 0 auto;
        margin-top: 50px;
    `};
`;

const FAQList = styled.div`
    width: 100%;
    max-width: 1000px;
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    justify-content: flex-start;
    gap: 10px;
`;

const FAQRowWrapper = styled.div`
    width: 100%;
`;

const FAQRow = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 30px;
    background: #121212;
    border-radius: 16px;
    min-height: 90px;
    box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.05);
    cursor: pointer;

    ${({ theme }) => theme.mediaWidth.upToSmall`
        padding:  10px 20px;
    `};

    .qs {
        max-width: calc(100% - 50px);
    }

    svg {
        cursor: pointer;
        width: 30px;
        height: 30px;
        flex-shrink: 0;
    }
`;
const FAQASRow = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    height: fit-content;
    justify-content: space-between;
    padding: 0 30px;
    margin-top: 20px;
    padding-bottom: 20px;

    ${({ theme }) => theme.mediaWidth.upToSmall`
        padding: 0 10px;
    `};
`;

const OpenIcon = styled(AddIcon)`
    color: ${({ theme }) => theme.c.primary01};
`;

const CloseIcon = styled(RemoveIcon)`
    color: ${({ theme }) => theme.c.primary01};
`;

function FAQItem({ qs, as }: { qs: string; as: string }) {
    const [isShow, setIsShow] = useState(false);
    const toggleRow = () => {
        setIsShow(!isShow);
    }
    return (
        <FAQRowWrapper>
            <FAQRow onClick={toggleRow}>
                <TYPE.main
                    fontSize={18}
                    mobileFz={16}
                    className={'qs'}
                    color="#fff"
                    wordBreak
                    style={{ wordBreak: 'break-word' }}
                >
                    {qs}
                </TYPE.main>
                {isShow ? <CloseIcon /> : <OpenIcon />}
            </FAQRow>
            {isShow && (
                <FAQASRow>
                    <TYPE.desc
                        fontSize={18}
                        mobileFz={14}
                        color="#fff"
                        wordBreak
                        style={{ wordBreak: 'break-word' }}
                    >
                        {as}
                    </TYPE.desc>
                </FAQASRow>
            )}
        </FAQRowWrapper>
    );
}

const FAQS = [
    {
        qs: 'How do I start exploring GOAT and mint my personal Space Capsule NFT?  ',
        as: 'To begin, connect your wallet and complete an initial Pre-mining or cross-chain transaction. Once completed, the system will guide you to the mint part where you can mint your unique Space Capsule NFT.',
    },
    {
        qs: `How can I collect GEC resources (GOAT Energy Units, also called GEC) to upgrade my Space Capsule?`,
        as: `You can earn Energy cubes through cross-chain transactions, staking, daily check-ins, and completing additional tasks. For example, bridging Bitcoin to the GOAT network or participating in specific staking missions will reward you with Energy cubes.`,
    },
    {
        qs: `How do I upgrade the modules in my Space Capsule NFT?`,
        as: `The Space Capsule has several modules (like the Resource Module and Defense Module) that can be upgraded. Each module requires a different amount of Energy Cubes to upgrade, which you can trigger manually or automatically once the requirements are met.`,
    },
    {
        qs: `Can I transfer or sell my minted Space Capsule NFT?  `,
        as: `Currently, the Space Capsule NFT is non-transferable, and each wallet address is allowed to mint only one. This restriction ensures a unique exploration experience for each user and prevents multiple ownership.`,
    },
    {
        qs: `What are the Lucky Draw events, and how can I unlock additional rewards?`,
        as: `Lucky Draw events are triggered when GOAT reaches certain milestones (such as hitting a specific TVL or transaction count). During these events, you may receive bonus resources, module power boosts, and more. Stay tuned for announcements on when these events will occur.`,
    },
    {
        qs: `What benefits do I receive from upgrading my Space Capsule modules? `,
        as: `Upgrading your Space Capsule modules improves your exploration efficiency and capabilities, such as gathering resources faster or enhancing defense abilities in collaborative missions. Reaching higher module levels can also unlock exclusive tasks and rewards.`,
    },
    {
        qs: `Is there a maximum amount of Energy Cubes I can collect daily? `,
        as: `Currently, there is no daily cap on Energy Cubes. You can complete as many tasks as you'd like or stake additional BTC to accumulate more Energy Cubes without restriction. This approach allows for unlimited exploration and resource collection based on your level of activity and investment.`,
    },
];

export default function FAQ() {
    return (
        <FAQWrapper>
            <Row justify="center" marginBottom="40px">
                <TYPE.title fontSize={50} mobileFz={20}>FAQ</TYPE.title>
            </Row>
            <FAQList>
                {FAQS.map((item, index) => {
                    return <FAQItem key={index} {...item} />;
                })}
            </FAQList>
        </FAQWrapper>
    );
}
